import React, { useState } from 'react';
import axios from 'axios';

const titleStyle = {
    display:"flex",
    padding: 16,
    textAlign:"center",
    contentAlign:"center",
    justifyContent:"center",
    background: 'rgba(199, 137, 236, 0.8)',
    color: '#fff',
    
};
const mainStyle = {
    padding: 16,
    textAlign:"center",
    contentAlign:"center",
    justifyContent:"center",
    fontSize: "20px",
    background: 'rgba(199, 137, 236, 0.8)',
    color: '#fff',
    
};


const PlayerEntry = () => {
   const [formData, setFormData] = useState({
      gameName: '',
		playerName: '',
		playerScore: 0,
   });
   const [message, setMessage] = useState("Input Player Data");
   
   const handleChange = (e) => {
      const { name, value } = e.target;
		   setFormData((prevData) => ({ ...prevData, [name]: value }));
   };
   
   const handleSubmit = async (e) => {
      e.preventDefault();
      try {
         const response = await axios.post('/addPlayer', formData);
			const data = response.data;
         console.log(data)
			checkIsNew(data)
      } catch (error) {
		   console.error('Error submitting form:', error);
			setMessage("Invalid Input try again.")
			}
		};

   const checkIsNew =(data)=> {
	   const isNew = data?.playerData.isNew
		if(isNew === 'y'){
		   setMessage(`${data.playerData.playerName} has been added to the Scoreboard with a score of ${data.playerData.playerScore}`)
		}else if(isNew ==='n'){
		   setMessage(`${data?.playerData.playerName}'s score has been updated to ${data.playerData.playerScore}`)
		}else{
		   setMessage("Awaiting player input")
		}
      return isNew;
   };

return (
    <div>
        <div style={titleStyle}>
            <h1>Player Score Submission</h1>
        </div><br/><br/>
        
        <form style={mainStyle} onSubmit={handleSubmit}>
        <label htmlFor="gameName">Select a Game</label><br/>
        <select id="gameName" name="gameName" value={formData.gameName} onChange={handleChange}>
          <option value='0'>--Select a Game--</option> 
          <option value="sonicAdventure2">Sonic Adventure 2 Battle</option> 
          <option value="pokemonYellow">Pokemon Yellow - Surfing Pikachu</option> 
          <option value="garou">Garou: Mark of the Wolves</option> 
          <option value="vibRibbon">Vib Ribbon</option> 
          <option value="gameWatch">Game and Watch Gallery 3 - Turtle Bridge</option> 
          <option value="mischiefMakers">Mischief Makers</option> 
          <option value="ff9jump">Final Fantasy 9 - Jump Rope</option> 
          <option value="justDance">Just Dance</option>
          <option value="spaceInvaders">Space Invaders 95</option>  
          <option value="nintendoLand">Nintendo Land - DK Crash Course</option>  
          <option value="robotUnicorn">Robot Unicorn Attack</option>  
          <option value="megaMan10">Mega Man 10 - Endless Mode</option>  
          <option value="evangelion">Evangelion: Typing Project Advanced</option>
          <option value="magicalTetris">Tetris: The Absolute The Grand Master 2</option>    
        </select><br/><br/>
        <label htmlFor="playerName">Player Name:</label><br/>
        <input type="text" name="playerName" value={formData.playerName} onChange={handleChange} placeholder="Player Name"/><br/><br/>
        <label htmlFor="playerScore">Player Score:</label><br/>
        <input type="number" name="playerScore" value={formData.playerScore} onChange={handleChange} placeholder="playerScore"></input><br/><br/>
        <button type="submit">Submit</button>
        </form><br/><br/>     
   
        <div style={mainStyle}>
            <p>{message}</p>
        </div>

    </div>
   
  );
};

export default PlayerEntry;
